import { ArrayUtils, JsonUtils, StringUtils } from "ts_utils";
import { LocalStorageHelper } from "../utilities/LocalStorageHelper";
import { Student } from "./Student";
import { TeamDO } from "./TeamDO";

export class StudentManager {
	public static students:Array<Student>;
	
	public static currentStudent:Student;
	
	/**populates [students] collection from localstorage json*/
	public static loadFromStorage():void {
		//[
		//		{
		//			'name' : 'jim',
		//			'teamCode' : '73848g',
		//			'scores' : {
		//				'rec1-1' : 95,
		//				'rec1-4' : 83,
		//				'rhy1-2' : 100
		//			}
		//		},
		// 		...
		//]
		StudentManager.students = [];
		let studentsJsonString = LocalStorageHelper.getStudentData();
		if (studentsJsonString == null){
			return;
		}
		let studentsJson = JsonUtils.decodeAsList(studentsJsonString);
		if (studentsJson != null){
			for (let studentJson of studentsJson){
				let student = new Student();
				student.name = studentJson['name'];
				student.teamCode = studentJson['teamCode'];
				student.teamName = studentJson['teamName'];
				student.parseScores(studentJson['scores']?? {});
				StudentManager.students.push(student);
				
				//if we had a currentStudent object, set its reference to the
				//newly created Student object so we don't have reference bugs.
				if (StudentManager.currentStudent != null && 
						StudentManager.currentStudent.name === student.name){
					StudentManager.currentStudent = student;
				}
			}
		}
	}
	
	/**saves the [students] collection to storage*/
	public static saveToStorage(moveCurrentStudentToTop:boolean):void {
		let students = StudentManager.students;
		if (moveCurrentStudentToTop && StudentManager.currentStudent != null){
			if (ArrayUtils.remove(StudentManager.currentStudent, students)){
				students.splice(0, 0, StudentManager.currentStudent);
			}
		}
		let output = this._createStudentsJson();
		LocalStorageHelper.saveStudentData(output);
	}
	
	/**creates a new [Student] object. Remember to call [saveToStorage] to save
	 * the student permanently.*/
	public static createStudent(name:string, team:TeamDO,
			insertAtTop:boolean = true):Student {
		let student = new Student();
		student.name = name;
		student.teamCode = team?.code;
		student.teamName = team?.name;
		student.scores = new Map<string, number>();
		if (insertAtTop){
			StudentManager.students.splice(0, 0, student);
		}
		else {
			StudentManager.students.push(student);
		}
		
		return student;
	}
	
	/**returns true if any student has the requested name*/
	public static hasStudentWithName(name:string):boolean {
		return StudentManager.students.some((u) => u.name === name);
	}
	
	/**sets the [currentStudent]. If no matching name is found, the student is 
	 * not changed.*/
	public static setCurrentStudentByName(name:string):void {
		let student = StudentManager.students.find((u) => u.name === name);
		if (student != null){
			StudentManager.currentStudent = student;
		}
	}
	
	/**generates a json string that can be saved to localstorage*/
	private static _createStudentsJson():string {
		let output:Array<any> = [];
		for (let student of StudentManager.students){
			let studentJson = {
				'name': student.name,
				'scores': student.getScoresMapAsObject()
			};
			if (StringUtils.isNotEmpty(student.teamCode)){
				studentJson['teamCode'] = student.teamCode;
			}
			if (StringUtils.isNotEmpty(student.teamName)){
				studentJson['teamName'] = student.teamName;
			}
			output.push(studentJson);
		}
		return JsonUtils.encode(output);
	}
}